import lazyWithPreload from 'react-lazy-with-preload';

const RedirectOldScreenLazy = lazyWithPreload(
  () => import('./redirect-old-screen')
);

export { RedirectOldScreenLazy };
